/*=================================================
    summary: 老師 看 / 改 學生考卷 填空題 Fill In Question 單元
             練習 寫一寫             LUSeqNo: 26
             回家作業 句型練習        LUSeqNo: 27
             Practice Writing Grammar Exercises
             Review Writing Grammar Exercises

    remarks: 000 Tim 2021/12/08 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentFillInQuestion from './AssignmentFillInQuestion.module.scss'
import '../../../../Utils/OldContentInlinClass.css'
import {GlobalLibs} from 'bc-react-package'

import parse from 'html-react-parser'


// #region Const
const IMAGE_DISPLAY_WIDTH = 700
const MAX_FEEDBACK_CHARACHERS = 1000 // Textarea最大的數字限制
// #endregion Const

// #region State Member Variables
let marrStateFeedbackText = []
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let marrDisplayQuestion = []
let mstrImagePrefix = ""

let marrContentData = []
let mintSQIndex4PreloadThumbnailImage = 0
let mintImgIndex4PreloadThumbnailImage = 0
let mintSQIndex4PreloadOriginalImage = 0
let mintImgIndex4PreloadOriginalImage = 0
// #endregion Member Variables


const COMP_NAME = "AssignmentFillInQuestion"

function AssignmentFillInQuestion(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [feedbackTextArray, setFeedbackTextArray] = useState([])
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrImagePrefix = window.Globals.GetResourcePrefix(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Image)

        RegisterGetTeacherFeedback()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update feedbackTextArray
    useEffect(() => {
        marrStateFeedbackText = feedbackTextArray

        console.log(COMP_NAME + ".Update feedbackTextArray: marrStateFeedbackText: ", marrStateFeedbackText)    
    }, [feedbackTextArray])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false

            setFeedbackTextArray([])
            setUpdateDataTime(0)
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        InitContentDataProcessBegin()
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 貼上學生答案 按鈕
    remarks: 000 Tim 2021/12/02 Create
             001 Tim 2022/01/21 超過 最大字數 直接截斷   Tim22.01.21
    ===========================================*/
    function PasteEventHandler(StateFeedbackTextArray, QuestionIndex, FillInQIndex, FQAnswer)
    {
        console.log(COMP_NAME + ".PasteEventHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrFeedbackText = JSON.parse(JSON.stringify(StateFeedbackTextArray))
        let strComment = arrFeedbackText[QuestionIndex][FillInQIndex] + FQAnswer
        // 超過 最大字數 直接截斷   Tim22.01.21
        if (strComment.length > MAX_FEEDBACK_CHARACHERS)
        {
            strComment = strComment.substr(0, MAX_FEEDBACK_CHARACHERS)
        }

        arrFeedbackText[QuestionIndex][FillInQIndex] = strComment
        setFeedbackTextArray(arrFeedbackText)
    } // end of PasteEventHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Feedback 改變 事件
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function FeedbackChangeHandler(e, StateFeedbackTextArray, QuestionIndex, FillInQIndex)
    {
        // console.log(COMP_NAME + ".FeedbackChangeHandler: e.target.value: ", e.target.value)
        let arrFeedbackText = JSON.parse(JSON.stringify(StateFeedbackTextArray))
        arrFeedbackText[QuestionIndex][FillInQIndex] = e.target.value

        console.log(COMP_NAME + ".FeedbackChangeHandler arrFeedbackText: ", arrFeedbackText)
        setFeedbackTextArray(arrFeedbackText)
    } // end of FeedbackChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        // console.log(COMP_NAME + ".CloseLoadingMask: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CloseLoadingMask BEGIN")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #region LoadingMask and Alert

    // #region Other Functions
    /*===========================================
    summary: 註冊 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RegisterGetTeacherFeedback ()
    {
        let objCallbackData = {
            "Action": "RegisterGetTeacherFeedback",
            "Function": GetTeacherFeedback
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterGetTeacherFeedback

    /*===========================================
    summary: 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function GetTeacherFeedback ()
    {
        console.log(COMP_NAME + ".GetTeacherFeedback: marrDisplayQuestion:", marrDisplayQuestion)

        let objTeacherFeedback = null
        let arrTeacherFeedback = []
        let intIndex = 0
        let intCount = marrDisplayQuestion.length
        let intFQIndex = 0
        let intFQCount = 0
        let arrFillInQuestion = []

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            intFQIndex = 0
            intFQCount = marrDisplayQuestion[intIndex].FillInQ.length
            arrFillInQuestion = marrDisplayQuestion[intIndex].FillInQ

            for (intFQIndex = 0; intFQIndex < intFQCount; intFQIndex++)
            {
                objTeacherFeedback = {
                    "AnswerID": arrFillInQuestion[intFQIndex].AnswerID,
                    "FQSeqNo": arrFillInQuestion[intFQIndex].FQSeqNo,
                    "TeacherFeedbackText": ""
                }
                if (
                    (typeof(marrStateFeedbackText[intIndex][intFQIndex]) !== 'undefined') &&
                    (marrStateFeedbackText[intIndex][intFQIndex] !== null) &&
                    (marrStateFeedbackText[intIndex][intFQIndex] !== "") 
                    )
                {
                    objTeacherFeedback.TeacherFeedbackText = marrStateFeedbackText[intIndex][intFQIndex]
                }

                arrTeacherFeedback.push(objTeacherFeedback)
            } // end of for (intFQIndex = 0;
        } // end of for (intIndex = 0;

        return arrTeacherFeedback
    } // end of GetTeacherFeedback

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadImage)

        marrContentData = []

        let arrKeywordList = []
        let objContent = null

        // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小，且顯示題目縮圖
        // Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示

        props.LearningUnitData.SuperQuestion.forEach((SuperQuestion) => {
            // Step 1. 讀取 ContentHtml 流程
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SuperQuestion.ContentHTML.MajorLangKeyword : SuperQuestion.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(SuperQuestion.ContentHTML.TextWithHeight, arrKeywordList, mstrImagePrefix)

            marrContentData.push(objContent)
        })

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        CloseLoadingMask()

        marrDisplayQuestion = FormatFQQuestionData(props.LearningUnitData, props.TeacherAssignmentData)
        
        // 先顯示出來
        setUpdateDataTime(new Date().getTime())

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd

    // #region PreloadImage
    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintSQIndex4PreloadThumbnailImage = 0
        mintImgIndex4PreloadThumbnailImage = 0

        if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
    } // end of PreloadThumbnailImageProcessBegin

    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 4. 將 圖片高度 正確計算之後，回寫進去 ContentHtml，再 顯示畫面
        marrContentData.forEach((ContentData) => {
            // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)

            console.log("ContentData: ", ContentData)
        }) // end of forEach marrContentData

        console.log("PreloadThumbnailImageProcessEnd END marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    } // end of PreloadThumbnailImageProcessEnd

    /*===========================================
    summary: 讀取 縮圖 題目圖片
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function LoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(SQIndex, ImgIndex, this.width, this.height)
        }; // end of image onload
        // objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].Url
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].ThumbnailImageUrl
    } // end of LoadThumbnailImage

    /*===========================================
    summary: 讀取 縮圖 題目圖片完成 事件
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function ThumbnailImageLoadedHandler(SQIndex, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", SQIndex, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[SQIndex].ImageList[ImgIndex].Width = Width
            marrContentData[SQIndex].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[SQIndex].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler END DisplayHeight: ", parseInt(marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight))

            GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler ContentData null")
        }
    } // end of ThumbnailImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 縮圖
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadThumbnailImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadThumbnailImage++
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadThumbnailImage++
            mintImgIndex4PreloadThumbnailImage = 0

            if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
            else
            {
                GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    } // end of GotoNextLoadThumbnailImage

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")

        mintSQIndex4PreloadOriginalImage = 0
        mintImgIndex4PreloadOriginalImage = 0

        if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
    } // end of PreloadOriginalImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")
    } // end of PreloadOriginalImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 題目圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(SQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalImage

    /*===========================================
    summary: 讀取 原圖 題目圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalImageLoadedHandler(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", SQIndex, ImgIndex)

        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[SQIndex].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[SQIndex].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)
            marrDisplayQuestion[SQIndex].ContentText = marrContentData[SQIndex].ContentText
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalImageLoadedHandler ContentData null")
        }
    } // end of OriginalImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadOriginalImage++
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadOriginalImage++
            mintImgIndex4PreloadOriginalImage = 0

            if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
            else
            {
                GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalImage
    // #endregion PreloadImage

    /*===========================================
    summary: 初始化 填空題 答案資料
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function FormatFQQuestionData(LearningUnit, TeacherAssignment)
    {
        console.log(COMP_NAME + ".FormatFQQuestionData: ", LearningUnit, TeacherAssignment)

        let arrSuperQuestion = LearningUnit.SuperQuestion
        let arrDisplayQuestion = []
        let objDisplayQuestion = null
        let objFillInQ = null

        let intSQIndex = 0
        let intSQCount = arrSuperQuestion.length
        let intFQIndex = 0
        let intFQCount = 0
        let arrAnswer = []
        let objAnswer = null
        let intNAIndex = 0

        let arrFillInQ = []
        
        let strTeacherFeedbackText = ""
        let arrTeacherFeedbackText = []
        let arrSubTeacherFeedbackText = []

        let objContent = null
        let strQuestionTextCN = ""

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
        }

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            // 處理 顯示的 Content
            objContent = marrContentData[intSQIndex]
            console.log(COMP_NAME + ".FormatFQQuestionData: objContent: ", objContent)

            objDisplayQuestion = {
                "SQSeqNo": arrSuperQuestion[intSQIndex].SQSeqNo,
                "ContentText": objContent.ContentText,
                "FillInQ": []
            }

            intFQIndex = 0
            intFQCount = arrSuperQuestion[intSQIndex].FillInQ.length
            arrFillInQ = arrSuperQuestion[intSQIndex].FillInQ
            arrSubTeacherFeedbackText = []

            for (intFQIndex = 0; intFQIndex < intFQCount; intFQIndex++)
            {
                objFillInQ = {
                    "FQSeqNo": arrFillInQ[intFQIndex].FQSeqNo,
                    "QuestionText": arrFillInQ[intFQIndex].Q,
                    "QuestionTextCN": "",
                    "AnswerText": "",
                    "FQAnswer": "",
                    "AnswerID": 0,
                    "TeacherFeedbackText": ""
                }

                let intSQSeqNo = parseInt(arrSuperQuestion[intSQIndex].SQSeqNo)
                let intFQSeqNo = parseInt(arrFillInQ[intFQIndex].FQSeqNo)

                // 找出 顯示 題目文字
                if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    strQuestionTextCN = arrFillInQ[intFQIndex].MajorQ
                    objFillInQ.AnswerText = arrFillInQ[intFQIndex].MajorA
                }
                else
                {
                    strQuestionTextCN = arrFillInQ[intFQIndex].MinorQ
                    
                    objFillInQ.AnswerText = arrFillInQ[intFQIndex].MinorA
                }

                if (
                    (typeof(strQuestionTextCN) !== 'undefined') &&
                    (strQuestionTextCN !== null) &&
                    (strQuestionTextCN !== "")
                    )
                {
                    objFillInQ.QuestionText = strQuestionTextCN
                }

                // 找出 使用者 選擇的答案
                objAnswer = arrAnswer.find(AnswerData => 
                    (
                        (parseInt(AnswerData.SQSeqNo) === intSQSeqNo) &&
                        (parseInt(AnswerData.FQSeqNo) === intFQSeqNo)
                    )
                )

                strTeacherFeedbackText = ""

                if (
                    (typeof(objAnswer) !== 'undefined') &&
                    (objAnswer !== null)
                    )
                {
                    objFillInQ.AnswerID = objAnswer.AnswerID
                    objFillInQ.FQAnswer = objAnswer.FQAnswer

                    if (
                        (typeof(objAnswer.TeacherFeedbackText) !== 'undefined') &&
                        (objAnswer.TeacherFeedbackText !== null) &&
                        (objAnswer.TeacherFeedbackText !== "")
                        )
                    {
                        objFillInQ.TeacherFeedbackText = objAnswer.TeacherFeedbackText
                        strTeacherFeedbackText = objAnswer.TeacherFeedbackText
                    } // end of if (objAnswer.TeacherFeedbackText !== null)
                } // end of if (objAnswer !== null)

                arrSubTeacherFeedbackText.push(strTeacherFeedbackText)

                objDisplayQuestion.FillInQ.push(objFillInQ)
            } // end of for (intFQIndex = 0;
            arrTeacherFeedbackText.push(arrSubTeacherFeedbackText)
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSQIndex = 0;

        setFeedbackTextArray(arrTeacherFeedbackText)

        console.log(COMP_NAME + ".FormatFQQuestionData arrTeacherFeedbackText: ", arrTeacherFeedbackText)
        console.log(COMP_NAME + ".FormatFQQuestionData arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatFQQuestionData
    // #endregion Other Functions

    // #region Render元件
    /*===========================================
    summary: 正確答案區域 顯示Component  
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function ComponentSuggestedAnswerArea( {AnswerText} )
    {   
        return(
            <>
                <div className={cssAssignmentFillInQuestion.divSuggestedAnswerTitle}>
                    {window.gAppUI.LBL_SuggestedAnswer}
                </div>

                <div className={cssAssignmentFillInQuestion.divSuggestedAnswerText}>
                    {AnswerText}
                </div>
            </>
        )
    } // end of ComponentSuggestedAnswerArea
                
    /*===========================================
    summary: 學生作答區域 顯示Component  
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function ComponentStudentAnswerArea( {FillInQData} )
    {   
        return(
            <>
                <div className={cssAssignmentFillInQuestion.divQuestionText}>
                    {FillInQData.QuestionText}
                </div>

                <div className={cssAssignmentFillInQuestion.divAnswerText}>
                    {FillInQData.FQAnswer}
                </div>
            </>
        )
    } // end of ComponentStudentAnswerArea

    /*===========================================
    summary: FillInQNo 顯示Component  
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function ComponentFillInQNo( {FillInQIndex} )
    {   
        let strNo = (FillInQIndex + 1).toString() + "."
        return(
            <div className={cssAssignmentFillInQuestion.divFillInQNo}>
                {strNo}
            </div>
        )
    } // end of ComponentFillInQNo
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Teacher Feedback 打分數模式 的顯示
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function RenderTeacherFeedbackResultWrapper(FillInQData)
    {
        return (
            <div className={cssAssignmentFillInQuestion.divSuggestedTeacherFeedbackMain}>
                <div className={cssAssignmentFillInQuestion.divSuggestedTeacherFeedbackTitle}>
                    {window.gAppUI.LBL_TeachersComments}:
                </div>

                <div className={cssAssignmentFillInQuestion.divFeedback4Result}>
                    {FillInQData.TeacherFeedbackText}
                </div>
            </div>
        )
    } // end of RenderTeacherFeedbackResultWrapper

    /*===========================================
    summary: Render Teacher Feedback 打分數模式 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderTeacherFeedback4ScoreItWrapper(QuestionIndex, FillInQIndex, FQAnswer)
    {
        return (
            <div className={cssAssignmentFillInQuestion.divSuggestedTeacherFeedbackMain}>
                <div className={cssAssignmentFillInQuestion.divSuggestedTeacherFeedbackTitle}>
                    {window.gAppUI.LBL_AddComments}
                </div>

                <label htmlFor="textareaFeedback" className={cssAssignmentFillInQuestion.divHidden}>
                    {window.gAppUI.LBL_WritingCommentsPlaceHolder}
                </label>
                <textarea id="textareaFeedback"
                    className={cssAssignmentFillInQuestion.txtFeedback} 
                    value={feedbackTextArray[QuestionIndex][FillInQIndex]}
                    placeholder={window.gAppUI.LBL_WritingCommentsPlaceHolder} 
                    maxLength={MAX_FEEDBACK_CHARACHERS}
                    onChange={(event) => FeedbackChangeHandler(event, feedbackTextArray, QuestionIndex, FillInQIndex)}
                />

                <div className={cssAssignmentFillInQuestion.divPasteRow}>
                    <div className={cssAssignmentFillInQuestion.btnPaste} onClick={() => PasteEventHandler(feedbackTextArray, QuestionIndex, FillInQIndex, FQAnswer)}> 
                        {window.gAppUI.BTN_PasteStudentAnswer}
                    </div>
                </div>
            </div>
        )
    } // end of RenderTeacherFeedback4ScoreItWrapper

    /*===========================================
    summary: Render Teacher Feedback 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderTeacherFeedbackWrapper(QuestionIndex, FillInQData, FillInQIndex, AssignReportStatus)
    {
        if (AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            return RenderTeacherFeedback4ScoreItWrapper(QuestionIndex, FillInQIndex, FillInQData.FQAnswer)
        }
        else
        {
            return RenderTeacherFeedbackResultWrapper(FillInQData)
        }
    } // end of RenderTeacherFeedbackWrapper
    
    /*===========================================
    summary: Render Question Sub Unit 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderQuestionSubUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)
    {
        return (
            <div className={cssAssignmentFillInQuestion.divQuestionSubUnit}>
                <ComponentStudentAnswerArea FillInQData={FillInQData}/>

                <ComponentSuggestedAnswerArea AnswerText={FillInQData.AnswerText}/>
                
                {RenderTeacherFeedbackWrapper(QuestionIndex, FillInQData, FillInQIndex, props.AssignReportStatus)}
            </div>
        )
    } // end of RenderQuestionSubUnitWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)
    {
        return (
            <>
                <ComponentFillInQNo FillInQIndex={FillInQIndex}/>

                {RenderQuestionSubUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)}
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Question Title Area 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentFillInQuestion.divQuestionTitleArea}>
                <div className={cssAssignmentFillInQuestion.divContentText}>
                    {parse(QuestionData.ContentText)}
                </div>
            </div>
        )
    } // end of RenderQuestionTitleAreaWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentFillInQuestion.divContent}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                        <div key={QuestionIndex} className={cssAssignmentFillInQuestion.divQuestionUnitMain}>
                            {RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)}

                            {QuestionData.FillInQ.map((FillInQData, FillInQIndex) =>
                                <div key={FillInQIndex}  className={cssAssignmentFillInQuestion.divQuestionUnitArea}>
                                    {RenderQuestionUnitWrapper(QuestionIndex, FillInQData, FillInQIndex)}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentFillInQuestion.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentFillInQuestion